
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/shared/wiki/jst/WikiPageEdit';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <h1 class=\"title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'title': ((depth0 && depth0.title)),
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.edit_page_title", "Edit %{title}", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.edit_page_title", "Edit %{title}", options)))
    + "</h1>\n  ";
  return buffer;
  }

function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n    <h1 class=\"title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.create_page_title", "New Page", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.create_page_title", "New Page", options)))
    + "</h1>\n  ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.content_is_locked), {hash:{},inverse:self.program(8, program8, data),fn:self.program(6, program6, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program6(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n        <input name=\"title\" type=\"hidden\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\">\n      ";
  return buffer;
  }

function program8(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n        <label for=\"title\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.title_label", "Page Title", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.title_label", "Page Title", options)))
    + "</label>\n        <input id=\"title\" name=\"title\" type=\"text\" class=\"span4 title\" value=\"";
  if (helper = helpers.title) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.title); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  buffer += escapeExpression(stack1)
    + "\" maxlength=\"255\" autofocus>\n      ";
  return buffer;
  }

function program10(depth0,data) {
  
  var buffer = "", stack1, helper;
  buffer += "\n    ";
  if (helper = helpers.body) { stack1 = helper.call(depth0, {hash:{},data:data}); }
  else { helper = (depth0 && depth0.body); stack1 = typeof helper === functionType ? helper.call(depth0, {hash:{},data:data}) : helper; }
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }

function program12(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <label for=\"wiki_page_body\" class=\"hidden-readable\" aria-hidden=\"true\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "raw_html_editor_e3993e41", "Raw HTML Editor", options) : helperMissing.call(depth0, "t", "raw_html_editor_e3993e41", "Raw HTML Editor", options)))
    + "</label>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.edit_with_block_editor), {hash:{},inverse:self.program(15, program15, data),fn:self.program(13, program13, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program13(depth0,data) {
  
  
  return "\n      <div id=\"block_editor\" class=\"block-editor\"></div>\n    ";
  }

function program15(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <textarea id=\"wiki_page_body\" rows=\"20\" cols=\"40\" name=\"body\" class=\"body\" aria-hidden=\"true\"";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.PAGE_RIGHTS)),stack1 == null || stack1 === false ? stack1 : stack1.update), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.convertApiUserContent || (depth0 && depth0.convertApiUserContent),options={hash:{
    'forEditing': (1)
  },data:data},helper ? helper.call(depth0, (depth0 && depth0.body), options) : helperMissing.call(depth0, "convertApiUserContent", (depth0 && depth0.body), options)))
    + "</textarea>\n    ";
  return buffer;
  }
function program16(depth0,data) {
  
  
  return " autofocus";
  }

function program18(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <fieldset class=\"responsive-control-group options\">\n      <legend class=\"control-label wiki-legend\"><h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.options_label", "Options", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.options_label", "Options", options)))
    + "</h2></legend>\n      <div class=\"controls\">\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.SELECT_ROLES), {hash:{},inverse:self.noop,fn:self.program(19, program19, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.CAN_SET_TODO_DATE), {hash:{},inverse:self.noop,fn:self.program(25, program25, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH), {hash:{},inverse:self.noop,fn:self.program(27, program27, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      </div>\n    </fieldset>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.show_assign_to), {hash:{},inverse:self.noop,fn:self.program(30, program30, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program19(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <label id=\"editing_roles_label\"  for=\"editing_roles\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "users_allowed_to_edit_this_page_d6d316d0", "Users allowed to edit this page", options) : helperMissing.call(depth0, "t", "users_allowed_to_edit_this_page_d6d316d0", "Users allowed to edit this page", options)))
    + "</label>\n          <select id=\"editing_roles\" aria-label=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "users_allowed_to_edit_this_page_d6d316d0", "Users allowed to edit this page", options) : helperMissing.call(depth0, "t", "users_allowed_to_edit_this_page_d6d316d0", "Users allowed to edit this page", options)))
    + "\" name=\"editing_roles\" class=\"responsive-width\">\n            ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.SHOW)),stack1 == null || stack1 === false ? stack1 : stack1.COURSE_ROLES), {hash:{},inverse:self.program(23, program23, data),fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          </select>\n        ";
  return buffer;
  }
function program20(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <option value=\"teachers\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.TEACHER_ROLE), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.course_editing_roles.only_teachers", "Only teachers", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.course_editing_roles.only_teachers", "Only teachers", options)))
    + "</option>\n              <option value=\"teachers,students\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.STUDENT_ROLE), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.course_editing_roles.teachers_and_students", "Teachers and students", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.course_editing_roles.teachers_and_students", "Teachers and students", options)))
    + "</option>\n              \n              <option value=\"teachers,students,members\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.ANYONE_ROLE), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.MEMBER_ROLE), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.course_editing_roles.anyone", "Anyone", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.course_editing_roles.anyone", "Anyone", options)))
    + "</option>\n            ";
  return buffer;
  }
function program21(depth0,data) {
  
  
  return " selected";
  }

function program23(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n              <option value=\"members\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.MEMBER_ROLE), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.editing_roles.only_members", "Only members", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.editing_roles.only_members", "Only members", options)))
    + "</option>\n              <option value=\"members,public\"";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.IS)),stack1 == null || stack1 === false ? stack1 : stack1.ANYONE_ROLE), {hash:{},inverse:self.noop,fn:self.program(21, program21, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += ">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.editing_roles.anyone", "Anyone", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.editing_roles.anyone", "Anyone", options)))
    + "</option>\n            ";
  return buffer;
  }

function program25(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <div class=\"controls-section\">\n            <label for=\"student_planner_checkbox\" class=\"checkbox\">\n            <input value=\"1\" type=\"checkbox\" id=\"student_planner_checkbox\" name=\"student_planner_checkbox\" "
    + escapeExpression((helper = helpers.checkedIf || (depth0 && depth0.checkedIf),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.todo_date), options) : helperMissing.call(depth0, "checkedIf", (depth0 && depth0.todo_date), options)))
    + " />\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "add_to_student_to_do_58e66b4b", "Add to student to-do", options) : helperMissing.call(depth0, "t", "add_to_student_to_do_58e66b4b", "Add to student to-do", options)))
    + "\n            </label>\n            <div id=\"todo_date_container\"></div>\n          </div>\n        ";
  return buffer;
  }

function program27(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n          ";
  stack1 = helpers['if'].call(depth0, ((stack1 = ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.FEATURES)),stack1 == null || stack1 === false ? stack1 : stack1.scheduled_page_publication), {hash:{},inverse:self.noop,fn:self.program(28, program28, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        ";
  return buffer;
  }
function program28(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n            <div class=\"controls-section\">\n              <label for=\"publish_at_input\">\n                "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "publish_at_3fd340d1", "Publish At", options) : helperMissing.call(depth0, "t", "publish_at_3fd340d1", "Publish At", options)))
    + "\n                <input id=\"publish_at_input\" type=\"text\" class=\"datetime_field input-medium\" name=\"publish_at\"\n                  value=\""
    + escapeExpression((helper = helpers.datetimeFormattedWithTz || (depth0 && depth0.datetimeFormattedWithTz),options={hash:{},data:data},helper ? helper.call(depth0, (depth0 && depth0.publish_at), options) : helperMissing.call(depth0, "datetimeFormattedWithTz", (depth0 && depth0.publish_at), options)))
    + "\"\n                  data-tooltip='{\"position\":\"top\",\"force_position\":\"true\"}' />\n              </label>\n            </div>\n          ";
  return buffer;
  }

function program30(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <fieldset class=\"responsive-control-group options\">\n      <legend class=\"control-label wiki-legend\"><h2>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.assign_to_label", "Assign Access", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.assign_to_label", "Assign Access", options)))
    + "</h2></legend>\n      <div class=\"controls\">\n        <div id=\"assign-to-mount-point-edit-page\"></div>\n      </div>\n    </fieldset>\n\n      ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.course_pace_with_mastery_paths), {hash:{},inverse:self.noop,fn:self.program(31, program31, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n    ";
  return buffer;
  }
function program31(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n      <div class=\"responsive-control-group options\">\n        <label class=\"control-label\"><strong>"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "mastery_paths_cc4096c2", "Mastery Paths", options) : helperMissing.call(depth0, "t", "mastery_paths_cc4096c2", "Mastery Paths", options)))
    + "</strong></label>\n        <div class=\"controls\">\n          <div id=\"mastery-paths-toggle-edit-page\"></div>\n        </div>\n      </div>\n      ";
  return buffer;
  }

function program33(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = helpers.unless.call(depth0, ((stack1 = (depth0 && depth0.ENV)),stack1 == null || stack1 === false ? stack1 : stack1.horizon_course), {hash:{},inverse:self.noop,fn:self.program(34, program34, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program34(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <button class=\"btn btn-default save_and_publish\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.buttons.save_and_publish", "Save & Publish", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.buttons.save_and_publish", "Save & Publish", options)))
    + "</button>\n        ";
  return buffer;
  }

  buffer += "<div class=\"edit-content\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.page_id), {hash:{},inverse:self.program(3, program3, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  <div id=\"edit_wikipage_title_container\" class=\"edit-header\">\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.EDIT_TITLE), {hash:{},inverse:self.noop,fn:self.program(5, program5, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  </div>\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.content_is_locked), {hash:{},inverse:self.program(12, program12, data),fn:self.program(10, program10, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.EDIT_ROLES), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<div class=\"form-actions clearfix\">\n  <div>\n    <label for=\"notify_of_update\" class=\"checkbox clearfix pull-left\" style=\"margin-top:5px\">\n      "
    + escapeExpression((helper = helpers.checkbox || (depth0 && depth0.checkbox),options={hash:{},data:data},helper ? helper.call(depth0, "notify_of_update", options) : helperMissing.call(depth0, "checkbox", "notify_of_update", options)))
    + "\n      "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.notify_users_text", "Notify users that this content has changed", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.notify_users_text", "Notify users that this content has changed", options)))
    + "\n    </label>\n    <div class=\"page-edit__action_buttons\">\n      <button class=\"btn cancel\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.buttons.cancel", "Cancel", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.buttons.cancel", "Cancel", options)))
    + "</button>\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.CAN)),stack1 == null || stack1 === false ? stack1 : stack1.PUBLISH_NOW), {hash:{},inverse:self.noop,fn:self.program(33, program33, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      <button class=\"btn btn-primary submit\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("wiki.wiki_page_edit")
  },data:data},helper ? helper.call(depth0, "wiki.wiki_page_edit.buttons.save", "Save", options) : helperMissing.call(depth0, "t", "wiki.wiki_page_edit.buttons.save", "Save", options)))
    + "</button>\n    </div>\n  </div>\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  